import React from 'react';
import { Box, Alert, Button, Typography } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function BillingTossFail() {
  const nav = useNavigate();
  const [sp] = useSearchParams();

  const provider = sp.get('provider') || 'toss';
  const code = sp.get('code');
  const message = sp.get('message');
  const invoiceId = sp.get('invoiceId');

  return (
    <Box sx={{ maxWidth: 560, mx: 'auto', p: 3 }}>
      <Alert severity="error" sx={{ mb: 2 }}>
        결제가 실패했습니다.
        <br />
        {provider ? `provider: ${provider}` : ''}
        {code ? ` / code: ${code}` : ''}
        {message ? ` / message: ${message}` : ''}
      </Alert>

      {!!invoiceId && (
        <Typography variant="body2" sx={{ mb: 2, opacity: 0.8 }}>
          invoiceId: {invoiceId}
        </Typography>
      )}

      <Button variant="outlined" onClick={() => nav('/mypage?tab=billing', { replace: true })}>
        마이페이지로 돌아가기
      </Button>
    </Box>
  );
}